// src/components/UpdateUserModal.js
import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

function UpdateUserModal({ onClose, onUpdated }) {
  const [ime, setIme] = useState("");
  const [priimek, setPriimek] = useState("");

  const handleUpdate = async () => {
    const userId = localStorage.getItem("userId");
    if (!userId) return;

    try {
      await axios.put(`https://fnm-backend.aibc-robotics.com/users/${userId}`, {
        ime,
        priimek,
      });

      toast.success("Ime in priimek sta bila uspešno posodobljena!");
      onUpdated(`${ime} ${priimek}`); // Posodobi prikazano ime
      onClose();
    } catch (err) {
      console.error("Napaka pri posodobitvi:", err);
      toast.error("Napaka pri posodobitvi uporabnika.");
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50"
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white p-6 rounded-xl shadow-lg space-y-4 w-full max-w-md"
      >
        <h2 className="text-xl font-semibold text-gray-800">Posodobi podatke</h2>
        <input
          type="text"
          value={ime}
          onChange={(e) => setIme(e.target.value)}
          placeholder="Novo ime"
          className="w-full border border-gray-300 p-2 rounded"
        />
        <input
          type="text"
          value={priimek}
          onChange={(e) => setPriimek(e.target.value)}
          placeholder="Nov priimek"
          className="w-full border border-gray-300 p-2 rounded"
        />
        <div className="flex justify-end space-x-2">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-600 hover:underline"
          >
            Prekliči
          </button>
          <button
            onClick={handleUpdate}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Shrani
          </button>
        </div>
      </div>
    </div>
  );
}

export default UpdateUserModal;
